import type { HelpSection } from './helpContent.types'

export const expertHelpContent: HelpSection[] = [
  {
    title: 'Creating Content Modules',
    subSections: [
      {
        entries: [
          {
            question: 'Where do I create a Content Module?',
            answer:
              'Go to the Content Library and select New Module. In a channel, this opens the Content Module workflow.',
          },
          {
            question: 'What is required to save a Content Module?',
            answer: 'A Primary File is required. The module cannot be saved without one.',
          },
          {
            question: 'Can I edit the generated title and description?',
            answer: 'Yes. Experts can edit the auto-generated title and description.',
          },
          {
            question: 'Which file types can I use?',
            answer:
              'You can use png, jpg, tiff, mp4, mov, mp3, wav, m4a, txt, md, pdf, pptx, docx, csv and xlsx, or enter content manually.',
          },
        ],
      },
    ],
  },
  {
    title: 'Publishing, Review, and Prioritization',
    subSections: [
      {
        entries: [
          {
            question: 'Does saving publish a Content Module?',
            answer:
              'No. Saving creates or updates the module. The module must be published before End Users can access it.',
          },
          {
            question: 'Can I test a Content Module before publishing it?',
            answer: 'Yes. Use Test in App, then switch to End User - Test in the mobile app.',
          },
          {
            question: 'Who can publish a Content Module?',
            answer:
              'Program Managers can publish their own Content Modules and Expert-created Content Modules that are in Pending status. Experts can publish their own Content Modules only when they have Bypass Review permission.',
          },
          {
            question: 'What is Bypass Review?',
            answer:
              'Bypass Review is a permission that allows an Expert owner to publish their own Content Modules without Program Manager approval. Program Managers manage this permission from the Content Module owner settings in the Content Library.',
          },
        ],
      },
    ],
  },
  {
    title: 'Metrics',
    subSections: [
      {
        entries: [
          {
            question: 'What are Metrics in the Sidekick Platform?',
            answer:
              'Metrics track how End Users engage with content and Sidekicks, helping Experts measure effectiveness.',
          },
          {
            question: 'What kinds of data can I see?',
            answer:
              'You can view statistics such as module usage, frequency of Sidekick interactions, and which topics are most accessed.',
          },
          {
            question: 'Where do I find Metrics?',
            answer: 'In the Portal, go to the Metrics tab to review engagement and usage reports.',
          },
          {
            question: 'How are Metrics useful?',
            answer:
              'They show which content is most impactful, help identify gaps, and provide insight into user behavior.',
          },
        ],
      },
    ],
  },
  {
    title: 'Feedback',
    subSections: [
      {
        entries: [
          {
            question: 'Can guest users submit feedback?',
            answer: 'No. Guests cannot submit feedback. Feedback is available for authenticated End Users.',
          },
          {
            question: 'Can Trial Account users submit feedback?',
            answer:
              'Yes. Trial Account users are authenticated End Users during their trial period, so they can submit feedback while they have access.',
          },
        ],
      },
    ],
  },
]
